import styled from "styled-components";
import { fHeader } from "../../styles/global";

export const Title = styled.h1`
  ${fHeader}
  margin-bottom: 4.6rem;
`;

export const GalleriesList = styled.ul`
  border-top: 1px solid black;
  padding-top: 1.3rem;

  a {
    display: inline-block;

    &:hover {
      opacity: 0.5;
    }
  }

  li + li {
    margin-top: 1.2em;
  }
`;
